import React, { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import PrivateRoute from '../../utils/PrivateRoute/PrivateRoute';
import Loader from '../../common/Loader/Loader';
import { WorkoutDataProvider } from './core/providers/WorkoutDataProvider';
import { WORKOUT_ROUTES, WORKOUT_ROUTE_CONFIG } from './core/constants/routes';

const WorkoutPlanPage = lazy(() =>
  import('./workflow/plan/modify/WorkoutPlanPage')
);
const TemplateListPage = lazy(() =>
  import('./workflow/template/list/TemplateListPage')
);
const TemplateCreatePage = lazy(() =>
  import('./workflow/template/modify/TemplateCreatePage')
);
const TemplateEditPage = lazy(() =>
  import('./workflow/template/modify/TemplateEditPage')
);
const ReferenceDataPage = lazy(() =>
  import('./workflow/utils/ReferenceDataPage')
);
const ExerciseListPage = lazy(() =>
  import('./workflow/exercises/list/ExerciseListPage')
);
const ExerciseDetailPage = lazy(() =>
  import('./workflow/exercises/view/ExerciseDetailPage')
);

function WorkoutShell({ element: Page, isPrivate = false }) {
  const inner = isPrivate ? <PrivateRoute element={Page} /> : <Page />;
  return (
    <Suspense fallback={<Loader />}>
      <WorkoutDataProvider>{inner}</WorkoutDataProvider>
    </Suspense>
  );
}

const PAGE_BY_PATH = {
  [WORKOUT_ROUTES.PLAN_EDITOR]: WorkoutPlanPage,
  [WORKOUT_ROUTES.TEMPLATES_LIST]: TemplateListPage,
  [WORKOUT_ROUTES.TEMPLATES_NEW]: TemplateCreatePage,
  [WORKOUT_ROUTES.TEMPLATES_DETAIL]: TemplateEditPage,
  [WORKOUT_ROUTES.WORKOUT_REFERENCE_DATA]: ReferenceDataPage,
  [WORKOUT_ROUTES.EXERCISES_LIST]: ExerciseListPage,
  [WORKOUT_ROUTES.EXERCISES_NEW]: ExerciseDetailPage,
  [WORKOUT_ROUTES.EXERCISES_DETAIL]: ExerciseDetailPage,
};

/** Pre-built Route elements for use inside App Routes. */
export const workoutRouteElements = (
  <>
    {WORKOUT_ROUTE_CONFIG.map(({ path, isPrivate }) => (
      <Route
        key={path}
        path={path}
        element={<WorkoutShell element={PAGE_BY_PATH[path]} isPrivate={isPrivate} />}
      />
    ))}
  </>
);
